import { Observable } from "rxjs";
import { AfterViewInit, ChangeDetectorRef, Component, ContentChild, TemplateRef } from "@angular/core";

import { MedTemplateDirective } from "../../../directives/med-template.directive";
import { Breadcrumb, MedBreadcrumbService } from "./med-breadcrumb.service";

@Component({
  selector: "med-breadcrumb",
  templateUrl: "./med-breadcrumb.component.html",
  styleUrls: ["./med-breadcrumb.component.scss"],
})
export class MedBreadcrumbComponent implements AfterViewInit {
  constructor(private readonly breadcrumbService: MedBreadcrumbService, private cd: ChangeDetectorRef) {
    this.breadcrumbs$ = breadcrumbService.breadcrumbs$;
  }

  labelTemplate?: TemplateRef<any>;
  readonly breadcrumbs$: Observable<Breadcrumb[]>;

  @ContentChild(MedTemplateDirective) template!: MedTemplateDirective;

  ngAfterViewInit() {
    if (this.template) {
      this.labelTemplate = this.template.template;
    }

    this.cd.detectChanges();
  }
}
